function getVersionFromUserAgent() {
  let version = navigator.userAgent.match(/Chrome\/(\d+)/);
  if (!version) {
    version = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
  }
  return version
    ? version[1].replace('Chrome/', '').replace('Gecko) ', '')
    : null;
}

export default getVersionFromUserAgent;
